import { accountantIbkApi } from '../apiAccountantIbk';
import { clientIbkApi } from '../apiClientIbk';
import { ibkApi } from '../apiIbk';
import { baseApi } from './baseApi';
export const resetAllApiCaches = (dispatch) => {
    dispatch(ibkApi.util.resetApiState());
    dispatch(clientIbkApi.util.resetApiState());
    dispatch(accountantIbkApi.util.resetApiState());
    dispatch(baseApi.util.resetApiState());
};
